export default function setProcessedStatus(el, attr) {
  el.setAttribute(`data-wui-${attr}-processed`, '');
}
